export const STATIC_STATUS_KEYS = ['staticStatus#spam'];

export const STATIC_STATUSES = [
  {
    pk: '*',
    sk: 'staticStatus#spam',
    name: 'Spam',
    color: '#BDBDBD',
    type: 'closed',
  },
];
